// import { createStore } from 'vuex'

// const store = createStore({
//     state() {
//         return {
//             user: {},
//             webApplicationToShow: [],
//             dataLowConnection: {},
//         }
//     },

// })

// export default store

import Vuex from 'vuex'
// import createPersistedState from "vuex-persistedstate";
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = new Vuex.Store({
    state() {
        return {
            user: {},
            webApplicationToShow: [],
            dataLowConnection: {},
        }
    },
    mutations: {
        setStoredData(st, val) {
            if (st.storedData == undefined)
                st.storedData = []
            st.storedData.push(val)
        },
        clearStoredData(st) {
            st.storedData = []
        }

    },
    plugins: [vuexLocal.plugin]
});

export default store